




//Geis funcionais Anal




//Geis premium funcionais

import geisPremium1 from '../../img/Geis Premium funcionais/geis-premium (1).png'
import geisPremium2 from '../../img/Geis Premium funcionais/geis-premium (2).png'
import geisPremium3 from '../../img/Geis Premium funcionais/geis-premium (3).png'
import geisPremium4 from '../../img/Geis Premium funcionais/geis-premium (4).png'
import geisPremium5 from '../../img/Geis Premium funcionais/geis-premium (5).png'
import geisPremium6 from '../../img/Geis Premium funcionais/geis-premium (6).png'
import geisPremium7 from '../../img/Geis Premium funcionais/geis-premium (7).png'
import geisPremium8 from '../../img/Geis Premium funcionais/geis-premium (8).png'
import geisPremium9 from '../../img/Geis Premium funcionais/geis-premium (9).png'
import geisPremium10 from '../../img/Geis Premium funcionais/geis-premium (10).png'
import geisPremium11 from '../../img/Geis Premium funcionais/geis-premium (11).png'
import geisPremium12 from '../../img/Geis Premium funcionais/geis-premium (12).png'




//Lubrificantes

import lubrificante1 from '../../img/Lubrificantes/Lubrificante 1.png'
import lubrificante2 from '../../img/Lubrificantes/Lubrificante 2.png'
import lubrificante3 from '../../img/Lubrificantes/Lubrificante 3.png'
import lubrificante4 from '../../img/Lubrificantes/Lubrificante 4.png'
import lubrificante5 from '../../img/Lubrificantes/Lubrificante 5.png'
import lubrificante6 from '../../img/Lubrificantes/Lubrificante 6.png'
import lubrificante7 from '../../img/Lubrificantes/Lubrificante 7.png'
import lubrificante8 from '../../img/Lubrificantes/Lubrificante 8.png'
import lubrificante9 from '../../img/Lubrificantes/Lubrificante 9.png'
import lubrificante10 from '../../img/Lubrificantes/Lubrificante 10.png'
import lubrificante11 from '../../img/Lubrificantes/Lubrificante 11.png'





export const geisPremiumFuncionais = [

    {
        id: 7,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium1,
        descricao: 'Vibra, Esquenta.',
        completa: 'Prazer além da sua imaginação. "Sabor Menta" ',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 20.00
    },
    {
        id: 7.1,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium2,
        descricao: 'Vibra, Esquenta.',
        completa: 'Prazer além da sua imaginação. "Sabor Morango"',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 20.00
    },
    {
        id: 7.2,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium3,
        descricao: 'Vibra, Pulsa, Beijável, Esquenta.',
        completa: 'Prazer além da sua imaginação.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 69.50
    },
    {
        id: 7.3,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium4,
        descricao: 'Vibra, Pulsa...',
        completa: 'Vibra, Pulsa, Beijável, Esquenta "Sabor Maçã do amor"',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 58.60
    },
    {
        id: 7.4,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium5,
        descricao: 'Vibra, Pulsa...',
        completa: 'Vibra, Pulsa, Beijável, Esquenta "Sabor Chiclete"',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 58.60
    },
    {
        id: 7.5,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium6,
        descricao: 'Vibra, Pulsa...',
        completa: 'Vibra, Pulsa, Beijável, Esquenta "Sabor Vinho"',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 58.60
    },
    {
        id: 7.6,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium7,
        descricao: 'Vibra, Pulsa...',
        completa: 'Vibra, Pulsa, Beijável, Esquenta "Sabor Péssego"',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 58.60
    },
    {
        id: 7.7,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium8,
        descricao: 'Vibra, Pulsa...',
        completa: 'Vibra, Pulsa, Beijável, Esquenta "Sabor Gin Tônica"',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 58.60
    },
    {
        id: 7.8,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium9,
        descricao: 'Vibra, Pulsa...',
        completa: 'Vibra, Pulsa, Beijável, Esquenta "Sabor Morango"',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 58.60
    },
    {
        id: 7.9,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium10,
        descricao: 'Vibra, Pulsa...',
        completa: 'Vibra, Pulsa, Beijável, Esquenta "Sabor Menta"',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 58.60
    },
    {
        id: 7.10,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium11,
        descricao: 'Comestível "Sabor Morango"',
        completa: 'Prazer além da sua imaginação.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 22.80
    },
    {
        id: 7.11,
        type: 'unico',
        titulo: 'Gel premium',
        img: geisPremium12,
        descricao: 'Comestível "Sabor Chocolate"',
        completa: 'Prazer além da sua imaginação.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 22.80
    },

]



export const LubrificanteItems = [

    {
        id: 9,
        type: 'unico',
        titulo: 'Lubrificante',
        img: lubrificante1,
        descricao: 'Maçã do Amor',
        completa: 'Comestíveis, funcionais, a base d água.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 45.00
    },
    {
        id: 9.1,
        type: 'unico',
        titulo: 'Lubrificante',
        img: lubrificante2,
        descricao: 'Esquenta',
        completa: 'Comestíveis, funcionais, a base d água.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 45.00
    },
    {
        id: 9.2,
        type: 'unico',
        titulo: 'Lubrificante',
        img: lubrificante3,
        descricao: 'Algodão Doce',
        completa: 'Comestíveis, funcionais, a base d água.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 45.00
    },
    {
        id: 9.3,
        type: 'unico',
        titulo: 'Lubrificante Íntimo',
        img: lubrificante4,
        descricao: 'Ice Black',
        completa: 'Comestíveis, funcionais, a base d água.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 45.00
    },
    {
        id: 9.4,
        type: 'unico',
        titulo: 'Lubrificante Íntimo',
        img: lubrificante5,
        descricao: 'Neutro, a base d água',
        completa: 'Neutro, a base d água.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 30.00
    },
    {
        id: 9.5,
        type: 'unico',
        titulo: 'Gel Umectante',
        img: lubrificante6,
        descricao: 'Neutro, a base d água',
        completa: 'Neutro, a base d água.',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 25.00
    },
    {
        id: 9.6,
        type: 'unico',
        titulo: 'Gel para Massagem Corporal',
        img: lubrificante7,
        descricao: 'Neutro...',
        completa: 'Neutro, Efeito gelado, a base d água',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 20.00
    },
    {
        id: 9.7,
        type: 'unico',
        titulo: 'Gel para Massagem Corporal',
        img: lubrificante8,
        descricao: 'Neutro...',
        completa: 'Neutro, Efeito gelado',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 20.00
    },
    {
        id: 9.8,
        type: 'unico',
        titulo: 'Gel para Massagem Corporal',
        img: lubrificante9,
        descricao: 'Morango com champanhe',
        completa: 'Neutro, Aromático, a base d água',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 20.00
    },
    {
        id: 9.9,
        type: 'unico',
        titulo: 'Gel para Massagem Corporal',
        img: lubrificante10,
        descricao: 'Menta',
        completa: 'Neutro, Aromático, a base d água',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 20.00
    },
    {
        id: 9.10,
        type: 'unico',
        titulo: 'Lubrificante Corporal',
        img: lubrificante11,
        descricao: 'xxxx',
        completa: 'xxxxx',
        indicacao: 'Esse produto, não possui indicação de uso.',
        preco: 20.00
    },

]


